export default __webpack_public_path__ + "static/media/elena-joy.a4770068.jpg";